import { css, keyframes } from "@emotion/react";
// Constants
import { Color } from "../../constants/Colors";

export const SVG_GRADIENT_BLUE =
  "PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZlcnNpb249JzEuMScgd2lkdGg9JzUwJyBoZWlnaHQ9JzUwJz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9J3JlZGdyYWRpZW50Jz48c3RvcCBvZmZzZXQ9JzAnIHN0b3AtY29sb3I9JyMwMDUyN0YnLz48c3RvcCBvZmZzZXQ9JzEnIHN0b3AtY29sb3I9JyMwMDc3QjYnLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBpZD0nTGF5ZXJfMSc+PHBhdGggZD0nTTAsMCBMNTAsMCBMNTAsNTAgTDAsNTAgTDAsMCB6JyBmaWxsPSd1cmwoI3JlZGdyYWRpZW50KScgd2lkdGg9JzEwMCUnIGhlaWdodD0nMTAwJScvPjwvZz48L3N2Zz4=";
export const SVG_GRADIENT_WHITE =
  "PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZlcnNpb249JzEuMScgd2lkdGg9JzUwJyBoZWlnaHQ9JzUwJz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9J3JlZGdyYWRpZW50Jz48c3RvcCBvZmZzZXQ9JzAnIHN0b3AtY29sb3I9JyNGRkZGRkYnLz48c3RvcCBvZmZzZXQ9JzEnIHN0b3AtY29sb3I9JyNGRkZGRkYnLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBpZD0nTGF5ZXJfMSc+PHBhdGggZD0nTTAsMCBMNTAsMCBMNTAsNTAgTDAsNTAgTDAsMCB6JyBmaWxsPSd1cmwoI3JlZGdyYWRpZW50KScgd2lkdGg9JzEwMCUnIGhlaWdodD0nMTAwJScvPjwvZz48L3N2Zz4=";

// Keyframes for animations
const switchArrow = keyframes({
  from: {
    backgroundSize: "0% 100%",
    opacity: 1,
  },
  to: {
    backgroundSize: "100% 100%",
    opacity: 1,
  },
});

export const useStyles = (props) => ({
  button: css({
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer",
    userSelect: "none",
    zIndex: 1,
    fontSize: "14px",
  }),
  withIcon: css({
    alignItems: "center",
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
  }),
  buttonIconLeft: css({
    display: "flex",
    "& svg": {
      marginRight: 24,
    },
  }),
  buttonIconRight: css({
    display: "flex",
    "& svg": {
      marginLeft: 24,
    },
  }),
  primary: css({
    display: "inline-flex",
    fontFamily: "roboto-medium",
    paddingLeft: "32px",
    paddingRight: "32px",
    lineHeight: "42px",
    backgroundSize: "0% 100%",
    backgroundRepeat: "no-repeat",
    backgroundOrigin: "border-box",
    transition: "all .2s ease-in-out, background-size .3s ease",
    "&:hover": {
      backgroundSize: "100% 100%",
    },
    "&:active": {
      borderImage: "none",
      transition: "all .0s",
      backgroundImage: "none",
    },
  }),
  primaryblue: css({
    border: `2px solid ${Color.primary[600]}`,
    borderImage: `url('data:image/svg+xml;base64,${SVG_GRADIENT_BLUE}') 10% stretch`,
    backgroundImage: Color.gradient[100],
    color: Color.primary[600],
    "&:hover": {
      color: Color.neutral[0],
    },
    "&:active": {
      borderColor: Color.primary[900],
      backgroundColor: Color.primary[900],
      color: Color.neutral[0],
    },
  }),
  secondary: css({
    position: "relative",
    fontFamily: "roboto-medium",
    lineHeight: "24px",
    paddingTop: "3px",
    paddingBottom: "3px",
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    borderBottom: "2px solid transparent",
    display: "inline-flex",
    alignItems: "center",
    transition: "all .3s ease-in-out",
    "&::after": {
      position: "absolute",
      left: 0,
      bottom: 0,
      content: '""',
      width: "100%",
      transform: "scaleX(0)",
      transformOrigin: "0% 100%",
      transition: "all .3s ease-in-out",
    },
    "&:hover": {
      "&::after": {
        transform: "scaleX(1)",
      },
    },
  }),
  secondaryblue: css({
    color: Color.primary[600],
    "&:hover": {
      color: Color.primary[900],
    },
    "&::after": {
      borderBottom: `2px solid ${Color.primary[900]}`,
    },
  }),
});
